module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/assessment-list/assessment-list.component.css
// module id = ./src/app/admin/assessment-list/assessment-list.component.css
// module chunks = main